// @flow

// !!! IMPORTANT !!!
//
// This file is shared between the zapier/zapier and zapier/next-js repository.
// Any changes made here should be reflected in there as well.
// For more information, see: https://zapier.quip.com/xaKqAOpdhpY2#ZXFACA8Jnp9
import React from 'react';
import bemify, { toModifiers } from 'bemify-js';

import { Heading4 } from '@zapier/legacy-components';

import Img from 'web-ssr/app/common/components/Img';
import Link from 'web-ssr/app/common/components/Link';
import 'web-ssr/app/common/components/ContentHeader/MegaMenu.scss';

import type { KindType, RenderCallback } from 'web-ssr/app/common/types';

const bem = bemify('mega-menu');

export type MegaMenuLink = {
  title: string,
  href: string,
  image?: string,
};

export type MegaMenuLinkCollection = {
  title: string,
  titleLink?: string,
  children: MegaMenuLink[],
};

type Props = {
  kind?: KindType,
  links?: MegaMenuLinkCollection[],
  renderHeaderLink: RenderCallback | null,
};

const MegaMenu = ({ kind, links, renderHeaderLink }: Props) => {
  if (!links) {
    return null;
  }

  const collections = links.map(({ title, titleLink, children }, index) => {
    const titleNode = !titleLink ? (
      title
    ) : (
      <Link href={titleLink}>{title}</Link>
    );

    const enableColumnMode = Boolean(children.length > 6);

    const linkList = children.map((link, idx) => {
      if (link.image) {
        return (
          <li className={bem('__media')} key={idx}>
            <Img
              alt={link.title}
              className={bem('__media', '--figure')}
              maxDownloadWidth={100}
              src={link.image}
            />
            <Link className={bem('__media', '--body')} href={link.href}>
              {link.title}
            </Link>
          </li>
        );
      }

      return (
        <li className={bem('__link-item')} key={idx}>
          <Link className={bem('__link')} href={link.href}>
            {link.title}
          </Link>
        </li>
      );
    });

    return (
      <div className={bem('__content-section')} key={index}>
        <Heading4 className={bem('__title')}>{titleNode}</Heading4>
        <ul className={bem('__link-list', enableColumnMode ? '--columns' : '')}>
          {linkList}
        </ul>
      </div>
    );
  });

  const headerLink = !renderHeaderLink ? null : (
    <div className={bem('__header-link')}>{renderHeaderLink({})}</div>
  );

  return (
    <div className={bem(toModifiers(kind))}>
      {headerLink}
      <div className={bem('__container')}>{collections}</div>
    </div>
  );
};

export default MegaMenu;
